import { css } from 'lit';

export default css`

  :host {
    display: block;
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .form-control--inline-radio ::slotted(nile-radio) {
    display: inline-block;
    margin-right: var(--nile-spacing-3xl, var(--ng-spacing-3xl));
  }

  .form-control {
    border: none;
    padding: var(--nile-spacing-none, var(--ng-spacing-none));
    margin: var(--nile-spacing-none, var(--ng-spacing-none));
  }

  .form-control__label {
    padding: var(--nile-spacing-none, var(--ng-spacing-none));
    font-size: var(--nile-type-scale-3, var(--ng-font-size-text-sm));
    color: var(--nile-colors-dark-900, var(--ng-colors-text-primary-900));
    font-family: var(--nile-font-family-serif, var(--ng-font-family-body));
    font-style: normal;
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-regular));
    line-height: var(--nile-line-height-xsmall, var(--ng-line-height-text-xs));
    letter-spacing: 0.2px;
  }

  .radio-group--required .radio-group__label::after {
    content: '*';
    margin-inline-start: -2px;
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: var(--nile-spacing-none, var(--ng-spacing-none));
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;
